<template>
  <div class="section">
    <div>
      <slot name="info">
      </slot>
    </div>
    <div>
      <slot name="categories">
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    inject: ['$validator']
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/breakpoints.scss';

  .section {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    margin-bottom: 20px;

    @include media(ltTablet) {
      display: block;
    }

    &:not(:last-of-type):before {
      content: '';
      position: absolute;
      right: -10px;
      bottom: 0;
      left: -10px;
      height: 1px;
      background-color: $color-geyser;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Section.vue